import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const WhiteRightArrow = ({ className }) => {
    return (_jsxs("svg", { viewBox: "0 0 24 8", className: className, children: [_jsx("path", { fill: "white", d: "M0 4h21.6 M20 8l4-4l-4-4V8z" }), _jsx("path", { fill: "white", stroke: "white", strokeWidth: "2", d: "M0 4h21.6" })] }));
};
export default WhiteRightArrow;
//# sourceMappingURL=WhiteRightArrow.js.map